<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>用户信息</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="goBack">返回</el-button>
                </el-col>
            </el-row>
        </div>

        <el-row :gutter="20">
            <el-col :span="6">
                <div class="grid-content bg-purple" style="text-align:center;margin-top: 20px;">
                    <img width="80px" height="80px" :src="userInfo.avatarUrl" alt="" style="border-radius: 50%;">
                </div>
            </el-col>
            <el-col :span="6">
                <div class="grid-content bg-purple">
                    <p>微信ID：{{userInfo.wxid}}</p>
                    <p>昵称：{{userInfo.nickName}}</p>
                    <p>是否绑定微信：{{userInfo.wxid ? '已绑定' : '未绑定'}}</p>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="grid-content bg-purple">
                    <p>手机号：{{userInfo.username}}</p>
                    <p>注册时间：{{ new Date(userInfo.created).getFullYear()+'-'+(new Date(userInfo.created).getMonth()+1)+'-'+new Date(userInfo.created).getDate()+' '+new Date(userInfo.created).getHours()+':'+new Date(userInfo.created).getMinutes()+':'+new Date(userInfo.created).getSeconds()}}</p>
                    <p>是否实名：{{userInfo.isIdentified ? '已实名' : '未实名'}}</p>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="grid-content bg-purple">
                    <p>性别：
                        <span v-if="userInfo.gender === '1'">男</span>
                        <span v-if="userInfo.gender === '2'">女</span>
                        <span v-if="userInfo.gender === '0' || userInfo.gender === null">暂无</span>
                    </p>
                    <p v-if="Role === '1'">密码：
                        <el-button @click="changePsd">修改</el-button>
                    </p>
                    <p>客户端来源：
                        <span>{{clientTypeMap[userInfo.clientType]}}</span>
                    </p>
                </div>
            </el-col>
        </el-row>
        <el-form :inline="true" :model="userInfo" class="demo-form-inline">
            <el-form-item label="真实姓名" style="margin-right: 20px">
                <span>{{otherInfo.zmName || otherInfo.realName || '无'}}</span>
            </el-form-item>
            <el-form-item label="身份证号" style="margin-right: 20px">
                <span>{{otherInfo.zmIdCard || otherInfo.idCard || '无'}}</span>
            </el-form-item>
            <el-form-item label="工作单位／学校" style="margin-right: 20px">
                <span>{{otherInfo.institution || '无'}}</span>
            </el-form-item>
            <!-- <el-form-item label="省市区" style="margin-right: 20px">
                <span>{{addressInfo.province}}省{{addressInfo.city}}{{addressInfo.district}}</span>
            </el-form-item> -->
            <el-form-item label="现居住地址" style="margin-right: 20px">
                <span>{{otherInfo.address || '无'}}</span>
            </el-form-item>
        </el-form>
        <el-form label-width="100px" class="demo-ruleForm">
            <el-form-item label="已通过审核实名信息">
                <div>
                    <img v-for="(item,index) in otherInfo.pictures" v-if="index != 3 && userInfo.isIdentified" :key="index" :src="item" alt="" style="margin-right: 15px;width: 200px;">
                    <span v-if="!userInfo.isIdentified">暂无</span>
                </div>
            </el-form-item>
        </el-form>
        <el-form :inline="true" :model="userInfo" class="demo-form-inline">
            <el-form-item label="芝麻信用分值" style="margin-right: 20px">
                <span>{{userInfo.zmScore || 0}}</span>
            </el-form-item>
            <el-form-item label="已获得免押金额度（单位：元）" style="margin-right: 20px">
                <span>{{userInfo.totalLine || 0}}</span>
            </el-form-item>
            <el-form-item label="当前剩余免押金额度（单位：元）" style="margin-right: 20px">
                <span>{{userInfo.totalRemain || 0}}</span>
            </el-form-item>
            <el-form-item label="芝麻信用获取的免押金额度（单位：元）" style="margin-right: 20px">
                <span>{{userInfo.zmLine || 0}}</span>
            </el-form-item>
            <el-form-item label="实名认证获取的免押金额度（单位：元）" style="margin-right: 20px">
                <span>{{userInfo.identifiedLine || 0}}</span>
            </el-form-item>
        </el-form>
        <el-form label-width="100px" class="demo-ruleForm">
            <el-form-item label="学生证照片" >
                <img :src="otherInfo.pictures[3]" alt="" style="margin-right: 15px;width: 300px;"  v-if="otherInfo.pictures && otherInfo.pictures[3].length">
                <span v-else>暂无</span>
            </el-form-item>
        </el-form>
        <el-button type="info" @click="handleOrder">查看用户订单</el-button>

        <el-dialog title="修改密码" :visible.sync="dialogFormVisible">
            <el-form :model="psdForm" label-width="150px">
                <el-form-item label="密码">
                    <el-input v-model="psdForm.psd" auto-complete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitNew">确定修改</el-button>
            </div>
        </el-dialog>

        <el-dialog title="用户订单" :visible.sync="dialogOrderVisible" size="large">
            <el-table :data="orderData">
                <el-table-column property="orderNo" label="订单编号" width="150"></el-table-column>
                <el-table-column inline-template :context="_self" label="商品名" width="200">
                    <div v-if="row && row.dispalyExtra">
                        <p v-for="item in row.dispalyExtra.mainItems">{{item.name}}</p>
                    </div>
                </el-table-column>
                <el-table-column property="receiverName" label="收货人"></el-table-column>
                <el-table-column property="receiverTel" label="收货人电话"></el-table-column>
                <el-table-column property="address" label="收货地址"></el-table-column>
                <el-table-column property="counts" label="商品数量"></el-table-column>
                <el-table-column inline-template :context="_self" label="订单状态">
                    <div>
                        <span v-if="row.status === 0">待付款</span>
                        <span v-if="row.status === 1">待发货</span>
                        <span v-if="row.status === 2">交易关闭</span>
                        <span v-if="row.status === 3">待收货</span>
                        <span v-if="row.status === 4">待返还</span>
                        <span v-if="row.status === 5">待返还</span>
                        <span v-if="row.status === 6">待返还确认</span>
                        <span v-if="row.status === 7">已完成</span>
                        <span v-if="row.status === 8">退款中</span>
                        <span v-if="row.status === 9">已退款</span>
                        <span v-if="row.status === 100">已删除</span>
                    </div>
                </el-table-column>
            </el-table>
        </el-dialog>


    </div>
</template>

<script>
    import {
        getUsersDetail,
        getUserIdentification,
        getDefaultAddress,
        patchUsersPsd,
        getUserOrder
    } from '../../api/version'

    export default {
        data() {
            return {
                Role: sessionStorage.power,
                clientTypeMap: {
                    alipay: '支付宝小程序',
                    wechat: '微信小程序',
                    h5: 'H5网页APP'
                },
                userInfo: {},
                otherInfo: {},
                addressInfo: {},
                psdForm: {
                    psd: ''
                },
                orderData: [],
                dialogFormVisible: false,
                dialogOrderVisible: false
            }
        },

        created() {
            getUsersDetail(sessionStorage.userId, this.$route.params.id).then(res => {
                console.log(res.data)
                this.userInfo = res.data
                this.userInfo.zmLine = this.userInfo.zmLine/100
                this.userInfo.identifiedLine = this.userInfo.identifiedLine/100
            })

            getUserIdentification(sessionStorage.userId, this.$route.params.id).then(res => {
                this.otherInfo = res.data
                if (this.otherInfo.pictures) {
                    this.otherInfo.pictures.forEach((item, index) => {
                        if (item) {
                            this.otherInfo.pictures[index] = `https://img.shareplay.cc/${item}`
                        }

                    })
                }

            })

            getDefaultAddress(sessionStorage.userId, this.$route.params.id).then(res => {
                console.log(res.data)
                this.addressInfo = res.data
            })
            console.log(this.$route.params.id)
        },

        methods: {
            goBack() {
                this.$router.push('/userList')
            },
            changePsd() {
                this.dialogFormVisible = true
            },
            submitNew() {
                //提交新密码
                if (this.psdForm.psd) {
                    let data = {
                        isSetPassword: true,
                        password: this.psdForm.psd
                    }
                    patchUsersPsd(sessionStorage.userId, this.$route.params.id, data).then(res => {
                        if (res.data) {
                            this.dialogFormVisible = false
                            this.$message({
                                message: '成功修改密码',
                                type: 'success'
                            });
                        }
                    }, err => {
                        this.$message.error('修改密码失败')
                    })
                }


            },
            handleOrder() {
                this.dialogOrderVisible = true
                //查看用户订单
                getUserOrder(sessionStorage.userId, this.$route.params.id, JSON.stringify({
                    "order": "id desc"
                })).then(res => {
                    console.log(res.data)
                    res.data.orders.forEach( (item,index) => {
                        item.counts = 0
                        if(item.dispalyExtra && item.dispalyExtra.mainItems) {
                            item.dispalyExtra.mainItems.forEach( item2 => {
                                res.data.orders[index].counts += item2.amount
                            })
                        }
                    })
                    this.orderData = res.data.orders
                })
            }

        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// UserView.vue?2edfbfae